//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { catchError, lastValueFrom, map, Observable, of, throwError } from 'rxjs';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { TypeCurrencyDTO } from 'src/app/core/models/system/type/type-currency.dto';

@Injectable({ providedIn: 'root' })

export class TypesCurrencyService {
  
  public allCurrencyTypes: TypeCurrencyDTO[] | undefined;
  
  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
  
  public get(): Observable<TypeCurrencyDTO[]> {
    try {
      return this.httpClientService.get<TypeCurrencyDTO[]>(environment.eSimApi + eSimApiPaths.TypesCurrency);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.httpClientService.get<TypeCurrencyDTO[]>(environment.eSimApi + eSimApiPaths.TypesCurrency)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
    public getIdFromCurrencyCode(currencyCode: string): number {
    try {
      let currencyType: TypeCurrencyDTO | undefined=this.allCurrencyTypes?.find(x => x.currencyCode==currencyCode);
  
      return currencyType?.id ?? -1;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return -1;
    }
  }

  private idAndDescriptionConverter(typeCurrency: TypeCurrencyDTO) {
    return {id: typeCurrency.id, description: typeCurrency.currencyType + ` (${typeCurrency.currencyCode})`};
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
    
  public refreshCurrencyTypeValues() {
    try {
      this.get()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.allCurrencyTypes=data;
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
